export const T = {
  en_GB: {
    label: "Model portfolio",
    automatic: (p: { score: number | null; name: string | null }) =>
      p.score == null
        ? "Automatic"
        : p.name
          ? `Automatic — ${p.name} (matches risk score ${p.score})`
          : `Automatic (matches risk score ${p.score})`,
    automaticNoMatch: (score: number) => `Automatic — no portfolio matches risk score ${score}`,
    choose: "Choose a model portfolio",
    item: (p: { name: string; score: number }) => `${p.name} · score ${p.score}`,
    matching: "matching",
    deviates: (p: { goal: number; portfolio: number }) =>
      `Deviates from risk score — goal ${p.goal}, portfolio ${p.portfolio}`,
    noRiskScore: "Complete the risk assessment to choose a model portfolio.",
    selectionOff:
      "Choosing a portfolio from another risk score is turned off for this collection. You can return to Automatic.",
  },
  nb_NO: {
    label: "Modellportefølje",
    automatic: (p: { score: number | null; name: string | null }) =>
      p.score == null
        ? "Automatisk"
        : p.name
          ? `Automatisk — ${p.name} (samsvarer med risikoscore ${p.score})`
          : `Automatisk (samsvarer med risikoscore ${p.score})`,
    automaticNoMatch: (score: number) =>
      `Automatisk — ingen portefølje samsvarer med risikoscore ${score}`,
    choose: "Velg en modellportefølje",
    item: (p: { name: string; score: number }) => `${p.name} · score ${p.score}`,
    matching: "samsvarer",
    deviates: (p: { goal: number; portfolio: number }) =>
      `Avviker fra risikoscore — mål ${p.goal}, portefølje ${p.portfolio}`,
    noRiskScore: "Fullfør risikovurderingen for å velge en modellportefølje.",
    selectionOff:
      "Valg av portefølje fra en annen risikoscore er slått av for denne samlingen. Du kan gå tilbake til Automatisk.",
  },
} as const;
